{
    "send_email__title": "Sending receipts to customers by email?",
    "send_email__body": "This sends an email with standard wording and a receipt as a PDF attachment. The email will be sent from your mailbox to the contact you have stored.",

    "toast_confirm_email__title": "Receipt successfully sent via email",
    "toast_confirm_email__body": "It can now also be viewed in Enventa",

    "delete_order__title": "Cancel order?",
    "delete_order__body": "The order will not be saved. This cannot be undone.",

    "toast_confirm_delete_order__title": "Order deleted",
    "toast_confirm_delete_order__body": "The order was successfully deleted",

    "delete_quote__title": "Cancel quote?",
    "delete_quote__body": "The quote will not be saved. This cannot be undone.",

    "toast_confirm_delete_quote__title": "Quote deleted",
    "toast_confirm_delete_quote__body": "The quote has been successfully deleted",

    "action__submit_without_email": "Don't send Email",
    "action__submit_with_email": "Send Email"
}
